import React from "react";
import { X } from "lucide-react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
const LayoutFrame = ({ children }) => (
  <div className="bg-white rounded-lg shadow-md p-2 w-full sm:h-[350px] h-[150px] overflow-hidden border hover:border-black transition">
    <div className="sm:scale-[0.6] scale-[0.3] lg:scale-[0.7] origin-top-left w-[350%] lg:w-[140%] sm:w-[160%] h-[200%] sm:h-[140%]">
      {children}
    </div>
  </div>
);

const HeroPreview = () => (
  <div className="border border-dashed rounded-xl h-20 flex items-center justify-center text-[10px] text-gray-400 mb-3">
    Upload image
  </div>
);

const TextBlock = () => (
  <div className="space-y-2 mb-3">
    <div className="h-3 w-24 bg-gray-200 rounded" />
    <div className="h-2 w-full bg-gray-100 rounded" />
    <div className="h-2 w-5/6 bg-gray-100 rounded" />
  </div>
);

const ImageBlock = () => (
  <div className="bg-gray-100 border border-dashed rounded-lg h-24 flex items-center justify-center text-[9px] text-gray-400">
    Image
  </div>
);

const BlogPopup = ({ onClose }) => {
  const navigate = useNavigate();
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <motion.div
        initial={{ scale: 0.95, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.95, opacity: 0 }}
        className="relative bg-white/70 backdrop-blur-md border border-[#877D6F] rounded-xl mx-5 lg:ml-[6%] w-[95vw] lg:w-[80vw] lg:max-w-[1000px] sm:h-[80vh] h-[58vh] p-5 overflow-y-auto"
      >
        <button
          onClick={onClose}
          className="abolute top-4 right-4 bg-white rounded-full shadow-md p-1 hover:bg-gray-100 transition-all active:scale-90 z-20"
        >
          <X size={20} />
        </button>

        <p className="text-xl font-bold mb-10 text-[#877D6F] text-center">
          Select Layout
        </p>

        <div className="grid grid-cols-3 gap-2 sm:gap-4 w-full">
          {[1, 2, 3].map((num) => (
            <div
              key={num}
              onClick={() => {
                onClose();
                navigate(`/BlogLayout${num}`);
              }}
              className="w-full block cursor-pointer"
            >
              <motion.div
                className="cursor-pointer"
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
              >
                <LayoutFrame>
                  <HeroPreview />

                  {num === 1 && (
                    <>
                      <TextBlock /> <ImageBlock />
                      <div className="mt-3">
                        <TextBlock /> <ImageBlock />
                      </div>
                    </>
                  )}
                  {num === 2 && (
                    <>
                      <div className="grid grid-cols-2 gap-2 mb-3">
                        <TextBlock />
                        <ImageBlock />
                      </div>
                      <div className="grid grid-cols-2 gap-2">
                        <ImageBlock />
                        <TextBlock />
                      </div>
                    </>
                  )}
                  {num === 3 && (
                    <div className="space-y-3">
                      <div className="grid grid-cols-2 gap-2">
                        <TextBlock />
                        <ImageBlock />
                      </div>
                      <div className="grid grid-cols-2 gap-2">
                        <TextBlock />
                        <ImageBlock />
                      </div>
                    </div>
                  )}
                </LayoutFrame>
              </motion.div>
            </div>
          ))}
        </div>
      </motion.div>
    </div>
  );
};

export default BlogPopup;

// import React, { useState } from "react";
// import { X } from "lucide-react";
// import { motion } from "framer-motion";

// const LayoutFrame = ({ children }) => (
//   <div className="bg-white rounded-lg shadow-md p-2 w-full sm:h-[350px] h-[150px] overflow-hidden border hover:border-black transition">
//     <div className="sm:scale-[0.6] scale-[0.3] lg:scale-[0.7] origin-top-left w-[350%] lg:w-[140%] sm:w-[160%] h-[200%] sm:h-[140%]">
//       {children}
//     </div>
//   </div>
// );

// const HeroPreview = () => (
//   <div className="border border-dashed rounded-xl h-20 flex items-center justify-center text-[10px] text-gray-400 mb-3">
//     Upload cover image
//   </div>
// );

// const TextBlock = () => (
//   <div className="space-y-2 mb-3">
//     <div className="h-3 w-24 bg-gray-200 rounded" />
//     <div className="h-2 w-full bg-gray-100 rounded" />
//     <div className="h-2 w-5/6 bg-gray-100 rounded" />
//   </div>
// );

// const ImageBlock = () => (
//   <div className="bg-gray-100 border border-dashed rounded-lg h-24 flex items-center justify-center text-[9px] text-gray-400">
//     Image
//   </div>
// );

// const BlogPopup = ({ onClose }) => {
//   const [setSelectedLayout] = useState(null);

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
//       <motion.div
//         initial={{ scale: 0.95, opacity: 0 }}
//         animate={{ scale: 1, opacity: 1 }}
//         exit={{ scale: 0.95, opacity: 0 }}
//         className="relative bg-white/70 backdrop-blur-md border border-[#877D6F] rounded-xl mx-5 lg:ml-[6%] w-[95vw] lg:w-[80vw] lg:max-w-[1000px] sm:h-[80vh] h-[58vh] p-5 overflow-y-auto"
//       >
//         <button
//           onClick={onClose}
//           className="abolute top-4 right-4 bg-white rounded-full shadow-md p-1 hover:bg-gray-100 transition-all active:scale-90 z-20"
//         >
//           <X size={20} />
//         </button>

//         <p className="text-xl font-bold mb-10 text-[#877D6F] text-center">
//           Select Layout
//         </p>

//         <div className="grid grid-cols-3 gap-2 sm:gap-4 w-full">
//           {[1, 2, 3].map((num) => (
//             <motion.div
//               key={num}
//               onClick={() => setSelectedLayout(num)}
//               className="cursor-pointer w-full"
//               whileHover={{ scale: 1.02 }}
//               whileTap={{ scale: 0.98 }}
//             >
//               <LayoutFrame>
//                 <HeroPreview />
//                 <a href="/BlogLayout1">
//                   {num === 1 && (
//                     <>
//                       <TextBlock /> <ImageBlock />
//                       <div className="mt-3">
//                         <TextBlock /> <ImageBlock />
//                       </div>
//                     </>
//                   )}
//                 </a>
//                 <a href="/BlogLayout2">
//                   {num === 2 && (
//                     <>
//                       <div className="grid grid-cols-2 gap-2 mb-3">
//                         <TextBlock />
//                         <ImageBlock />
//                       </div>
//                       <div className="grid grid-cols-2 gap-2">
//                         <ImageBlock />
//                         <TextBlock />
//                       </div>
//                     </>
//                   )}
//                 </a>
//                 <a href="/BlogLayout3">
//                   {num === 3 && (
//                     <div className="space-y-3">
//                       <div className="grid grid-cols-2 gap-2">
//                         <TextBlock />
//                         <ImageBlock />
//                       </div>
//                       <div className="grid grid-cols-2 gap-2">
//                         <TextBlock />
//                         <ImageBlock />
//                       </div>
//                     </div>
//                   )}
//                 </a>
//               </LayoutFrame>
//             </motion.div>
//           ))}
//         </div>
//       </motion.div>
//     </div>
//   );
// };

// export default BlogPopup;

// // import React, { useState } from "react";
// // import { X } from "lucide-react";
// // import { motion } from "framer-motion";

// // const LayoutFrame = ({ children }) => (
// //   <div className="bg-white rounded-lg shadow-md p-2 w-full sm:h-[350px] h-[150px] overflow-hidden border hover:border-black transition">
// //     <div className="sm:scale-[0.6] scale-[0.3] lg:scale-[0.7] origin-top-left w-[350%] lg:w-[140%] sm:w-[160%] h-[200%] sm:h-[140%]">
// //       {children}
// //     </div>
// //   </div>
// // );

// // const HeroPreview = () => (
// //   <div className="border border-dashed rounded-xl h-20 flex items-center justify-center text-[10px] text-gray-400 mb-3">
// //     Upload image
// //   </div>
// // );

// // const TextBlock = () => (
// //   <div className="space-y-2 mb-3">
// //     <div className="h-3 w-24 bg-gray-200 rounded" />
// //     <div className="h-2 w-full bg-gray-100 rounded" />
// //     <div className="h-2 w-5/6 bg-gray-100 rounded" />
// //   </div>
// // );

// // const ImageBlock = () => (
// //   <div className="bg-gray-100 border border-dashed rounded-lg h-24 flex items-center justify-center text-[9px] text-gray-400">
// //     Image
// //   </div>
// // );

// // const BlogPopup = ({ onClose }) => {
// //   const [setSelectedLayout] = useState(null);

// //   return (
// //     <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
// //       <motion.div
// //         initial={{ scale: 0.95, opacity: 0 }}
// //         animate={{ scale: 1, opacity: 1 }}
// //         exit={{ scale: 0.95, opacity: 0 }}
// //         className="relative bg-white/70 backdrop-blur-md border border-[#877D6F] rounded-xl mx-5 lg:ml-[6%] w-[95vw] lg:w-[80vw] lg:max-w-[1000px] sm:h-[80vh] h-[58vh] p-5 overflow-y-auto"
// //       >
// //         <button
// //           onClick={onClose}
// //           className="abolute top-4 right-4 bg-white rounded-full shadow-md p-1 hover:bg-gray-100 transition-all active:scale-90 z-20"
// //         >
// //           <X size={20} />
// //         </button>

// //         <p className="text-xl font-bold mb-10 text-[#877D6F] text-center">
// //           Select Layout
// //         </p>

// //         <div className="grid grid-cols-3 gap-2 sm:gap-4 w-full">
// //           {[1, 2, 3].map((num) => (
// //             <motion.div
// //               key={num}
// //               onClick={() => setSelectedLayout(num)}
// //               className="cursor-pointer w-full"
// //               whileHover={{ scale: 1.02 }}
// //               whileTap={{ scale: 0.98 }}
// //             >
// //               <LayoutFrame>
// //                 <HeroPreview />
// //                 <a href="/">
// //                   {num === 1 && (
// //                     <>
// //                       <TextBlock /> <ImageBlock />
// //                       <div className="mt-3">
// //                         <TextBlock /> <ImageBlock />
// //                       </div>
// //                     </>
// //                   )}
// //                 </a>
// //                 <a href="/">
// //                   {num === 2 && (
// //                     <>
// //                       <div className="grid grid-cols-2 gap-2 mb-3">
// //                         <TextBlock />
// //                         <ImageBlock />
// //                       </div>
// //                       <div className="grid grid-cols-2 gap-2">
// //                         <ImageBlock />
// //                         <TextBlock />
// //                       </div>
// //                     </>
// //                   )}
// //                 </a>
// //                 <a href="/">
// //                   {num === 3 && (
// //                     <div className="space-y-3">
// //                       <div className="grid grid-cols-2 gap-2">
// //                         <TextBlock />
// //                         <ImageBlock />
// //                       </div>
// //                       <div className="grid grid-cols-2 gap-2">
// //                         <TextBlock />
// //                         <ImageBlock />
// //                       </div>
// //                     </div>
// //                   )}
// //                 </a>
// //               </LayoutFrame>
// //             </motion.div>
// //           ))}
// //         </div>
// //       </motion.div>
// //     </div>
// //   );
// // };

// // export default BlogPopup;
